import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import 'bloko/blocks/modal/modal.less';

/**
 * Заголовок модального окна
 */
export default function ModalHeader({ outlined, ...modalHeaderProps }) {
    return (
        <div
            {...modalHeaderProps}
            className={classnames('bloko-modal-header', {
                'bloko-modal-header_outlined': outlined,
            })}
        />
    );
}

ModalHeader.propTypes = {
    /** Контент */
    children: PropTypes.node,
    /** Добавлять ли подчеркивание к заголовку */
    outlined: PropTypes.bool,
};

ModalHeader.defaultProps = {
    outlined: false,
};
